document.addEventListener('DOMContentLoaded', function () {

  let loading = false;
  let finished = false;

  function getGrid() {
    return document.querySelector('#product-grid');
  }

  function getNextPage() {
    const pagination = document.querySelector('.pagination');

    if (!pagination) return null;

    const next = pagination.querySelector('a[rel="next"]');

    return next ? next.href : null;
  }

  async function loadMoreProducts() {

    if (loading || finished) return;

    const grid = getGrid();
    const nextUrl = getNextPage();

    if (!grid || !nextUrl) {
      finished = true;
      return;
    }

    loading = true;

    const loader = document.querySelector('.infinite-scroll-loader');

    if (loader) {
      loader.classList.add('is-loading');
    }

    try {

      const response = await fetch(nextUrl, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Unable to load products');
      }

      const html = await response.text();

      const parser = new DOMParser();

      const doc = parser.parseFromString(
        html,
        'text/html'
      );

      const newGrid = doc.querySelector('#product-grid');

      if (!newGrid) {
        finished = true;
        return;
      }

      const products = newGrid.querySelectorAll(
        ':scope > .grid__item'
      );

      if (!products.length) {
        finished = true;
        return;
      }

      products.forEach(function (product) {

        grid.appendChild(
          product.cloneNode(true)
        );

      });

      /*
       * Replace pagination with the
       * pagination from the new page.
       */
      const currentPagination =
        document.querySelector('.pagination');

      const newPagination =
        doc.querySelector('.pagination');

      if (currentPagination && newPagination) {

        currentPagination.replaceWith(
          newPagination.cloneNode(true)
        );

      } else if (!newPagination) {

        finished = true;

      }

    } catch (error) {

      console.error(
        'Infinite scroll error:',
        error
      );

    } finally {

      loading = false;

      if (loader) {
        loader.classList.remove('is-loading');
      }

    }
  }


  /*
   * Automatically load when the user
   * gets 800px from the bottom.
   */
  function checkScroll() {

    if (loading || finished) return;

    const scrollPosition =
      window.innerHeight + window.scrollY;

    const pageHeight =
      document.documentElement.scrollHeight;

    if (
      scrollPosition >= pageHeight - 800
    ) {

      loadMoreProducts();

    }

  }


  window.addEventListener(
    'scroll',
    checkScroll,
    { passive: true }
  );


  /*
   * Also check on page load.
   */
  checkScroll();

});